import type { FeatureMiddleware } from '@cast/api-client';
import { EvictorConfig } from '@cast/types-workload-eviction';

import {
  getIsClusterDemoMode,
  getIsOpDemoMode,
} from '@cast/infrastructure-demo';

import { rejectDemoClusterRequest } from '../utils';

const demoEvictorConfig: EvictorConfig = {
  enabled: false,
  dryRun: false,
  aggressiveMode: false,
  scopedMode: false,
  cycleInterval: '15m0s',
  nodeGracePeriodMinutes: 5,
  podEvictionFailureBackOffInterval: '5s',
  ignorePodDisruptionBudgets: false,
  softTainting: false,
  status: 'EVICTOR_STATUS_COMPATIBLE',
};

export const workloadEviction: FeatureMiddleware<'workloadEviction'> = {
  getConfig: async ({ next, resolve }) => {
    if (getIsOpDemoMode() || getIsClusterDemoMode()) {
      return resolve(demoEvictorConfig);
    }
    return next();
  },
  getAdvancedConfig: async ({ next, resolve }) => {
    if (getIsOpDemoMode() || getIsClusterDemoMode()) {
      return resolve({ evictionConfig: [] });
    }
    return next();
  },
  updateConfig: async ({ next }) => {
    if (getIsOpDemoMode() || getIsClusterDemoMode()) {
      return rejectDemoClusterRequest();
    }
    return next();
  },
  updateAdvancedConfig: async ({ next }) => {
    if (getIsOpDemoMode() || getIsClusterDemoMode()) {
      return rejectDemoClusterRequest();
    }
    return next();
  },
};
